// cast is a helper function which
// explicitly returns the type submitted
// Useful for explicitly casting objects to
// interfaces
export const cast = <T>(data: T): T => data
